import { SubmitButton, RadioList } from '~components'
import { useForm } from 'react-hook-form'
import { object, string } from '~utils/validation'
import { Values } from './interfaces'
import { useStore, useNavigate, usePathValidation } from '~hooks'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Styled from './styled'
import { useEffect } from 'react'
import { track } from '@amplitude/analytics-browser'
import { Vehicle } from '~services'
import { useRequest } from 'ahooks'
import { chunk } from 'lodash'

function VehicleTracking() {
  const { register: registerStore, update } = useStore()
  const { data: trackers } = useRequest(Vehicle.listTrackers)
  const options = chunk(trackers?.data, 5)

  const defaultValues = { vehicleTracking: registerStore?.vehicleTracking }
  const navigate = useNavigate()
  const schema = object({
    vehicleTracking: string().required(),
  })
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm({ resolver: yupResolver(schema), mode: 'onChange', defaultValues })

  useEffect(() => {
    track('cadastro_rastreador', {
      tipo_veiculo: registerStore.vehicleType,
      tipo_carroceria: registerStore.vehicleBody,
    })
  }, [])

  useEffect(() => {
    update({ register: { progress: 60 } })
  }, [update])

  usePathValidation([
    'cpf',
    'plate',
    'register.cellphone',
    'register.fullName',
    'register.rntrc',
    'register.vehicleType',
    'register.vehicleBody',
  ])

  function onSubmit(values: Values) {
    update({
      register: values,
    })
    navigate('/cadastrar/selfie', {
      state: { previousPath: '/cadastrar/rastreador-veiculo' },
    })
  }

  return (
    <Styled.Form
      onSubmit={handleSubmit(onSubmit)}
      aria-labelledby="form-vehicle-tracking-title"
    >
      <Styled.Title id="form-vehicle-tracking-title">
        O veículo tem rastreador?
      </Styled.Title>
      <Styled.Row>
        {options.map((optionList) => (
          <RadioList
            isOrderedList={false}
            list={optionList}
            name="vehicleTracking"
            register={register}
          />
        ))}
      </Styled.Row>
      <SubmitButton disabled={!isValid} width="350px">
        Continuar
      </SubmitButton>
    </Styled.Form>
  )
}

export default VehicleTracking
